import { Box, LinearProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PHASES } from "../../api/coach";

export default function PhaseIndicator({ phase }: { phase: string }) {
  const { t } = useTranslation("coach");
  const idx = PHASES.findIndex((p) => p.key === phase);
  const position = idx >= 0 ? idx + 1 : 1;
  const label = idx >= 0 ? t(PHASES[idx].labelKey) : phase;
  const pct = (position / PHASES.length) * 100;

  return (
    <Box>
      <Typography variant="caption" color="text.secondary" fontWeight={500}>
        {t("PhaseIndicator.progressLabel", { position, total: PHASES.length, label })}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={pct}
        color="secondary"
        sx={{ mt: 0.5, height: 6, borderRadius: 3 }}
      />
    </Box>
  );
}
